const initialState = {
    loading: false,
    add: null,
    adds: [],

}
export default function (state = initialState, action) {
    switch (action.type) {
        case "GET_ADD":
            return { ...state, add: action.payload }
        case "GET_ADD_ERROR":
            return { ...state, loading: false }
        case "GET_ADDS":
            return { ...state, adds: action.payload }
        case "DELETE_ADD":
            const addDelete = state.adds.filter(add => add._id !== action.payload)
            return { ...state, add: addDelete }

        default:
            return state

    }
}
